import * as d3 from 'd3'

export default {
  methods: {
    draw_Form() {
      if (this.sCanvasArea) this.sCanvasArea.remove()
      this.sCanvasArea = this.svg
      .append('g')
      .attr('id', 'Canvas_Area')
      .attr('transform', `translate(0.5, 0.5)`)
      .attr('font-family', 'roboto')

      let canvas = this.sCanvasArea
      .append('g')
      .attr('id', `text_area_${this.localId}`)

      canvas
      .append('foreignObject')
      .attr('x', this.json.textArea.x)
      .attr('y', this.json.textArea.y)
      .attr('width', this.json.textArea.width)
      .attr('height', this.json.textArea.height)
      .html(`
        <div xmlns="http://www.w3.org/1999/xhtml">
          <style>p { margin: 0; }</style>
          ${this.rawData[0].COMMENT}
        </div>
      `)

      let btn = canvas
      .append('g')
      .attr('id', `btns_${this.localId}`)
      .attr('transform', `translate(${this.json.button.x}, ${this.json.button.y})`)
      .attr('cursor', 'pointer')

      btn.append('image')
      .attr('xlink:href', 'https://cdn.jsdelivr.net/npm/@mdi/svg/svg/pencil.svg')
      .attr('width', 16)
      .attr('height', 16)
      .call(this.call_Link)

      // btn.append('image')
      // .attr('xlink:href', 'https://cdn.jsdelivr.net/npm/@mdi/svg/svg/refresh.svg')
      // .attr('x', 20)
      // .attr('width', 16)
      // .attr('height', 16)

    },

  }
}